import { request } from '@/utils/request'

export interface IPublicBody {
  __type: string
  __id: string
  __action: string
  __adapter: string
  __fields: Array<Record<string, any>>
}

export const changePublicBundle = (body: IPublicBody) => {
  return request('/api/node/set', {
    method: 'POST',
    body: JSON.stringify(body)
  })
}
